<template>
  <div class="live-overview">
    <div class="banner cooperation-banner">
      <div class="w1200">
        <h1 class="title">直播产品</h1>
        <p class="desc">全面支持直播和班课模式</p>
      </div>
    </div>
    <div v-if="$store.state.sceneClassName === 'app'" class="describe-area-app">
      <div class="d-item">
        <h1 class="i-title">直播：轻量型的个性化课堂</h1>
        <div class="i-subtitle i-subtitle-live">
          语音直播&amp;视频直播，按照讲师个性化教学需求创建直播，支持图文音频、录播直播、PPT直播、桌面共享直播等类型
        </div>
        <img
          :src="require('@/assets/images/live2.png')"
          alt=""
          class="live-img"
        />
      </div>
      <div class="d-item item-odd">
        <h1 class="i-title">班课：沉浸式互动教学课堂</h1>
        <div class="i-subtitle i-subtitle-live">
          可以实现从1V1至1V16的全面互动教学，满足多人开启实时连麦视频、白板画笔互动的教学需求
        </div>
        <img
          :src="require('@/assets/images/live3.png')"
          alt=""
          class="live-img"
        />
      </div>
    </div>
    <div v-else class="describe-area">
      <div class="swiper-pagination"></div>
      <swiper :options="swiperOptions">
        <swiper-slide>
          <div class="describe-content classroom-slide">
            <div class="describe-title">班课：沉浸式互动教学课堂</div>
            <div class="describe-tips">
              可以实现从1v1到1v16的全面互动教学、满足多人开启实时连麦、白板画笔互动的教学需求
            </div>
            <router-link to="/" class="know-more">进一步了解</router-link>
            <div class="describe-live-img-area">
              <img
                class="classroom-image"
                :src="require('@/assets/images/live2.png')"
                alt=""
              />
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="describe-content classroom-slide">
            <div class="describe-title">班课：沉浸式互动教学课堂</div>
            <div class="describe-tips">
              可以实现从1v1到1v16的全面互动教学、满足多人开启实时连麦、白板画笔互动的教学需求
            </div>
            <router-link to="/" class="know-more">进一步了解</router-link>
            <div class="describe-live-img-area">
              <img
                class="classroom-image"
                :src="require('@/assets/images/live3.png')"
                alt=""
              />
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="page-middle-part">
      <img
        v-if="$store.state.sceneClassName !== 'app'"
        class="middle-part-bg-img"
        :src="require('@/assets/images/live4.png')"
        alt=""
      />
      <div class="lz-tools-show-area">
        <div class="tools-area-title">
          丰富直播互动工具，适应不同场景和直播需求
        </div>
        <div class="tools-area-tips">
          白板、课件、测验、互动一应俱全，教育培训，引流带货，在线演示都能轻松满足
        </div>
        <div class="lz-tools">
          <div
            v-for="(item, index) in data1"
            :key="`ll_${index}`"
            class="tools-item"
          >
            <img class="tools-image" :src="item.img" alt="" />
            <div class="image-tips">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="open-steps-area">
        <div class="open-steps-title">三个简单步骤，开启一场直播</div>
        <div class="open-steps-tips">
          简单操作步骤好上手，节省讲师的时间精力成本
        </div>
        <div class="open-steps">
          <div class="step1 step-item">
            <img
              v-if="$store.state.sceneClassName === 'app'"
              class="step-left-top-bg"
              :src="require('@/assets/images/live4_app.png')"
              alt=""
            />
            <img
              v-else
              class="step-left-top-bg"
              :src="require('@/assets/images/live4.png')"
              alt=""
            />
            <img
              v-if="$store.state.sceneClassName === 'app'"
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live15_app.png')"
              alt=""
            />
            <img
              v-else
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live15.png')"
              alt=""
            />
            <div class="step-title">注册创建知链店铺</div>
            <div class="step-content">
              点击“立即体验”按钮，注册知链账号并创建自己专属的店铺。
            </div>
            <div class="step-btn">
              <a href="/" target="_blank">
                立即体验 <i class="el-icon-arrow-right"></i
              ></a>
            </div>
          </div>
          <div class="step2 step-item">
            <img
              v-if="$store.state.sceneClassName === 'app'"
              class="step-left-top-bg"
              :src="require('@/assets/images/live4_app.png')"
              alt=""
            />
            <img
              v-else
              class="step-left-top-bg"
              :src="require('@/assets/images/live4.png')"
              alt=""
            />
            <img
              v-if="$store.state.sceneClassName === 'app'"
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live16_app.png')"
              alt=""
            />
            <img
              v-else
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live16.png')"
              alt=""
            />
            <div class="step-title">创建直播间并下载工具</div>
            <div class="step-content">
              进入知链店铺管理台后，找到直播课堂并花3分钟设置好直播间，然后下载知链直播助手即可准备开始直播。
            </div>
          </div>
          <div class="step3 step-item">
            <img
              v-if="$store.state.sceneClassName === 'app'"
              class="step-left-top-bg"
              :src="require('@/assets/images/live4_app.png')"
              alt=""
            />
            <img
              v-else
              class="step-left-top-bg"
              :src="require('@/assets/images/live4.png')"
              alt=""
            />
            <img
              v-if="$store.state.sceneClassName === 'app'"
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live17_app.png')"
              alt=""
            />
            <img
              v-else
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live17.png')"
              alt=""
            />
            <div class="step-title">微信分享链接和学习</div>
            <div class="step-content">
              无需下载APP，直接把直播间链接或二维码海报发到微信群/朋友圈，学员点击就参与进来观看学习，支持付费观看和密码设置。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lz-live-advance-info">
      <div class="advance-info-title">搭建专属直播，选知链就够了</div>
      <div class="advance-info-tips">为什么推荐选择知链搭建专属直播？</div>
      <div class="advance-infos">
        <div class="advance-info-item">
          <img
            class="item-left-top-bg"
            :src="require('@/assets/images/live18' + getImgSuffix + '.png')"
            alt=""
          />
          <img
            class="item-right-bottom-bg"
            :src="require('@/assets/images/live19' + getImgSuffix + '.png')"
            alt=""
          />
          <div class="info-item-title">流量费用补贴优惠政策</div>
          <div class="info-item-content">
            知链采取流量补贴政策，直播免收流量费，班课的流量费用享受部分补贴，帮助客户降低直播成本。
          </div>
        </div>
        <div class="advance-info-item">
          <img
            class="item-left-top-bg"
            :src="require('@/assets/images/live18' + getImgSuffix + '.png')"
            alt=""
          />
          <img
            class="item-right-bottom-bg"
            :src="require('@/assets/images/live20' + getImgSuffix + '.png')"
            alt=""
          />
          <div class="info-item-title">专属服务管家陪伴指导</div>
          <div class="info-item-content">
            知链为客户提供7x24小时全程陪伴指导服务，手把手教会商家使用直播功能操作。
          </div>
        </div>
        <div class="advance-info-item">
          <img
            class="item-left-top-bg"
            :src="require('@/assets/images/live18' + getImgSuffix + '.png')"
            alt=""
          />
          <img
            class="item-right-bottom-bg"
            :src="require('@/assets/images/live21' + getImgSuffix + '.png')"
            alt=""
          />
          <div class="info-item-title">专注微信生态，支持H5/小程序</div>
          <div class="info-item-content">
            支持H5页面和小程序形式，满足公众号、微信群、朋友圈、微信私聊等社交场景，即开即用易传播。
          </div>
        </div>
        <div class="advance-info-item">
          <img
            class="item-left-top-bg"
            :src="require('@/assets/images/live18' + getImgSuffix + '.png')"
            alt=""
          />
          <img
            class="item-right-bottom-bg"
            :src="require('@/assets/images/live22' + getImgSuffix + '.png')"
            alt=""
          />
          <div class="info-item-title">功能齐全：教学能力+营销能力</div>
          <div class="info-item-content">
            包含数十种教学/营销工具，例如白板、考试、裂变、砍价等等，增强教学能力和营销能力。
          </div>
        </div>
      </div>
    </div>
    <div class="famous-user-info">
      <img
        class="famous-user-info-bt-img"
        :src="require('@/assets/images/live36.png')"
        alt=""
      />
      <div class="famous-user-info-title">
        知名客户的选择，他们都用知链搭建专属直播
      </div>
      <div class="famous-user-info-tips">
        看看他们都是怎么用知链解决直播场景问题？
      </div>
      <div class="famous-user-list">
        <div class="famous-users">
          <div
            v-for="(item, index) in data2"
            :key="`fu_${index}`"
            class="famous-user"
          >
            <img :src="item.img" alt="" />
            <div class="user-name">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="user-demo-area">
        <img
          v-if="$store.state.sceneClassName !== 'app'"
          class="demo-area-left-bottom-bg-img"
          :src="require('@/assets/images/live37.png')"
          alt=""
        />
        <img
          v-if="$store.state.sceneClassName !== 'app'"
          class="demo-area-right-top-bg-img"
          :src="require('@/assets/images/live38.png')"
          alt=""
        />
        <img
          class="user-demo-img"
          :src="require('@/assets/images/live35.png')"
          alt=""
        />
        <div class="user-demo-describe">
          <div class="user-demo-tips">
            知链直播教学工具，大大降低机构运营成本
          </div>
          <div class="user-demo-describe-content">
            深水有渔搭建了以训练内容、答疑为主的实时视频直播课和以学员分享为主的语音直播课，让更多学员获益。
          </div>
          <div class="user-use-tools">
            <div class="tools-tips">他们使用这些功能：</div>
            <div class="tools-list">
              <button class="tools-item" disabled="">实时视频直播</button>
              <button class="tools-item" disabled="">语音直播</button>
              <button class="tools-item" disabled="">超级会员</button>
              <button class="tools-item" disabled="">训练营</button>
              <button class="tools-item" disabled="">打卡</button>
            </div>
            <div
              v-if="$store.state.sceneClassName !== 'app'"
              class="demo-user-name"
            >
              (客户案例：深水有渔)
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-free
      title="现在试用，即可获得￥100班课直播流量费"
      desc="¥100直播流量费已打入账户，注册登录即可在“管理台-班课-账户”中查看"
      href="/"
    ></v-free>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay } from 'swiper';
import Free from '@/components/Free.vue';
SwiperCore.use([Pagination, Autoplay]);
const swiperPagination = ['直播', '班课'];
const data1 = [{
  title: '语音/录播/实时视频',
  img: require('@/assets/images/live5.png')
}, {
  title: '教学课件共享',
  img: require('@/assets/images/live6.png')
}, {
  title: '电子白板板书',
  img: require('@/assets/images/live7.png')
}, {
  title: '师生共享桌面',
  img: require('@/assets/images/live8.png')
}, {
  title: '直播随堂测验',
  img: require('@/assets/images/live9.png')
}, {
  title: '学生举手发言',
  img: require('@/assets/images/live10.png')
}, {
  title: '课堂互动交流',
  img: require('@/assets/images/live11.png')
}, {
  title: '课程录制回看',
  img: require('@/assets/images/live12.png')
}, {
  title: '发起点名签到',
  img: require('@/assets/images/live13.png')
}, {
  title: '直播数据统计',
  img: require('@/assets/images/live14.png')
}];
const data2 = [{
  title: '吴晓波频道',
  img: require('@/assets/images/live23.png')
}, {
  title: '十点课堂',
  img: require('@/assets/images/live24.png')
}, {
  title: '鸿学院',
  img: require('@/assets/images/live25.png')
}, {
  title: 'FPA性格色彩',
  img: require('@/assets/images/live26.png')
}, {
  title: '童行学院',
  img: require('@/assets/images/live27.png')
}, {
  title: '更好课堂',
  img: require('@/assets/images/live28.png')
}, {
  title: '简七理财',
  img: require('@/assets/images/live29.png')
}, {
  title: '峰阅',
  img: require('@/assets/images/live30.png')
}, {
  title: '牛气学堂',
  img: require('@/assets/images/live31.png')
}, {
  title: '新东方',
  img: require('@/assets/images/live32.png')
}, {
  title: '科学队长',
  img: require('@/assets/images/live33.png')
}, {
  title: '婷婷诗教',
  img: require('@/assets/images/live34.png')
}];
export default {
  data() {
    return {
      data1,
      data2,
      swiperOptions: {
        autoplay: 1500,
        speed: 1500,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class='${className}'>${swiperPagination[index]}</span>`;
          }
        }
      }
    };
  },
  computed: {
    getImgSuffix() {
      if (this.$store.state.sceneClassName === 'app') {
        return '_app';
      }
      return '';
    }
  },
  components: {
    'v-free': Free
  }
};
</script>

<style lang="scss">
.live-overview {
  .swiper-pagination {
    position: absolute;
    top: 96px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 416px;
    height: 68px;
    border-radius: 36px;
    border: 2px solid #1472ff;
  }
  .swiper-pagination-bullet {
    width: 208px;
    height: 64px;
    background-color: #fff;
    border-radius: 34px;
    font-size: 28px;
    font-weight: 400;
    color: #1472ff;
    line-height: 64px;
    opacity: 1;
    margin: 0;
  }
  .swiper-pagination-bullet-active {
    height: 68px;
    background: #1472ff;
    color: #fff;
  }
  .describe-area {
    position: relative;
    background-color: #fff;
  }
  .describe-area .swiper-container {
    max-width: 1200px;
    padding-top: 260px;
  }
  .describe-area
    .swiper-container
    .swiper-slide
    .describe-content
    .describe-title {
    height: 44px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }
  .describe-area
    .swiper-container
    .swiper-slide
    .describe-content
    .describe-tips {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
  }
  .describe-area .swiper-container .swiper-slide .describe-content .know-more {
    margin-top: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #1472ff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .describe-area
    .swiper-container
    .swiper-slide
    .describe-content
    .know-more
    img {
    margin-left: 8px;
    width: 12px;
  }
  .describe-area
    .swiper-container
    .swiper-slide
    .describe-content
    .describe-live-img-area {
    height: 657px;
    font-size: 0;
    text-align: center;
  }
  .describe-area
    .swiper-container
    .swiper-slide
    .describe-content
    .describe-live-img-area
    img.live-image {
    width: 886px;
  }
  .describe-area
    .swiper-container
    .swiper-slide
    .describe-content
    .describe-live-img-area
    img.classroom-image {
    width: 1174px;
  }
  .create-store-entrance-area,
  .describe-area,
  .describe-area .swiper-container .swiper-slide .describe-content,
  .display-flex-column-center,
  .famous-user-info,
  .page-middle-part .open-steps-area,
  .page-middle-part .lz-tools-show-area,
  .page-middle-part .lz-tools-show-area .lz-tools .tools-item,
  .lz-live-advance-info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.app .live-overview {
  .page-middle-part .lz-tools-show-area .lz-tools {
    width: auto;
  }
  .lz-live-advance-info {
    padding: 1.28rem 0.32rem;
    background: #ffffff;
    .advance-info-title {
      text-align: center;
      font-weight: 500;
      line-height: 0.72rem;
      font-size: 0.56rem;
    }
    .advance-info-tips {
      font-weight: 400;
      line-height: 0.44rem;
      font-size: 0.28rem;
      margin-top: 0.32rem;
      letter-spacing: -0.006rem;
      height: 1.76rem;
    }
    .advance-infos {
      width: 100%;
      display: block;
      margin-top: 0;
      .advance-info-item {
        width: 100%;
        margin: 0 0 0.32rem;
        padding: 0.48rem 0.32rem;
        height: 3.54rem;
        box-shadow: 0 10px 30px 0 rgba(102, 102, 102, 0.08);
        border-radius: 4px;
        .item-left-top-bg,
        .item-right-bottom-bg {
          width: 3.76rem;
          height: auto;
        }
        .item-right-bottom-bg {
          width: 2.26rem;
          height: auto;
        }
        .info-item-title {
          font-weight: 500;
          line-height: 0.5rem;
          font-size: 0.36rem;
          text-align: center;
        }
        .info-item-content {
          width: 4rem;
          margin-top: 0.32rem;
          line-height: 0.4rem;
          font-size: 0.28rem;
        }
      }
    }
  }
  .famous-user-info {
    background: rgba(20, 114, 255, 0.04);
    padding: 1.28rem 0.32rem;
    .famous-user-info-bt-img {
      display: none;
    }
    .famous-user-info-title {
      font-weight: 500;
      line-height: 0.72rem;
      font-size: 0.56rem;
      text-align: center;
    }
    .famous-user-info-tips {
      font-weight: 400;
      line-height: 0.44rem;
      font-size: 0.28rem;
      margin-top: 0.32rem;
      letter-spacing: -0.006rem;
      height: 1.76rem;
    }
    .famous-user-list {
      width: auto;
      background: transparent;
      .famous-users {
        width: auto;
        flex-wrap: wrap;
        justify-content: space-between;
        .famous-user {
          width: 2.08rem;
          height: auto;
          background: #fff;
          margin: 0 0 0.32rem;
          border-radius: 0.16rem;
          img {
            width: auto;
            max-width: 100%;
            height: 1.4rem;
          }
          .user-name {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.3rem;
            height: 0.88rem;
            line-height: 0.44rem;
            padding: 0 0.2rem;
          }
        }
      }
    }
    .user-demo-area {
      display: block;
      width: 100%;
      margin-top: 0.64rem;
      padding: 0;
      background-color: transparent;
      .user-demo-img {
        width: 6.86rem;
        height: 5.14rem;
        margin: 0;
      }
      .user-demo-describe {
        margin-top: 0.48rem;
        .user-demo-tips {
          margin-bottom: 0.32rem;
          font-size: 0.32rem;
          width: 100%;
        }
        .user-demo-describe-content {
          width: 100%;
          height: auto;
          margin: 0 0 0.32rem;
          font-size: 0.28rem;
          line-height: 0.44rem;
        }
      }
      .user-use-tools {
        margin-top: 0;
        .tools-tips {
          width: auto;
          height: auto;
          margin-bottom: 0.16rem;
          font-size: 0.28rem;
        }
        .tools-list {
          margin-top: 0;
          .tools-item {
            margin-right: 0.16rem;
            margin-left: 0;
            padding: 0.08rem;
            border-radius: 0.04rem;
            border-width: 0.02rem;
            font-size: 0.24rem;
          }
        }
      }
    }
  }
}
</style>
